

export const getEditorModalName = (Modal) => {
  if (!Modal.editorModalName) {
    throw new Error(`Component ${Modal.displayName} is missing an 'editorModalName' prop`);
  }
  return Modal.editorModalName;
};
